import { VehicleValuationStatus } from "@/api-schema-enums";

export const VEHICLE_VALUATION_STATUS_TRANSLATIONS = {
  [VehicleValuationStatus.Failed]: "fab:VehicleValuationStatusFailed",
  [VehicleValuationStatus.OverhaulNeeded]: "fab:VehicleValuationStatusOverhaulNeeded",
  [VehicleValuationStatus.VehicleSelectionRequired]: "fab:VehicleValuationStatusVehicleSelectionRequired",
  [VehicleValuationStatus.WaitingForConfirmation]: "fab:VehicleValuationStatusWaitingForConfirmation",
  [VehicleValuationStatus.InProgress]: "fab:VehicleValuationStatusInProgress",
  [VehicleValuationStatus.Confirmed]: "fab:VehicleValuationStatusConfirmed",
} satisfies Record<VehicleValuationStatus, string>;
